import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { TextLink } from '../../TextLink/TextLink.es.js';
import { useCollapsibleText } from '../CollapsibleText.Context/index.es.js';

const CollapsibleTextToggle = ({ variant = 'secondary', className, locale = {
    showMore: 'Show more',
    showLess: 'Show less'
} })=>{
    const { disabled, collapsed, expanded, setExpanded } = useCollapsibleText();
    const handleToggleCollapse = useCallback(()=>{
        setExpanded((prev)=>!prev);
    }, [
        setExpanded
    ]);
    if (disabled || !collapsed) {
        return null;
    }
    return jsx(TextLink, {
        className: classNames('cb-collapsible-text-toggle', className),
        "data-testid": "collapsible-text-button",
        onClick: handleToggleCollapse,
        size: "inherit",
        variant: variant,
        children: !expanded ? jsxs(Fragment, {
            children: [
                locale.showMore,
                jsx(Icon, {
                    className: "toggle-icon",
                    name: "ChevronDownSolid",
                    size: 24
                })
            ]
        }) : jsxs(Fragment, {
            children: [
                locale.showLess,
                jsx(Icon, {
                    className: "toggle-icon",
                    name: "ChevronUpSolid",
                    size: 24
                })
            ]
        })
    });
};

export { CollapsibleTextToggle };
//# sourceMappingURL=CollapsibleText.Toggle.es.js.map
